import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgStar = (props: SvgProps) => (
  <Svg fill="none" height={25} width={25} {...props}>
    <Path
      d="M12.573 1.256a.48.48 0 0 1 .854 0l3.345 6.577a.48.48 0 0 0 .36.257l7.455 1.058a.48.48 0 0 1 .262.823l-5.375 5.082a.48.48 0 0 0-.143.432l1.271 7.193a.48.48 0 0 1-.69.51l-6.694-3.416a.48.48 0 0 0-.436 0l-6.694 3.417a.48.48 0 0 1-.69-.51l1.27-7.194a.48.48 0 0 0-.142-.432L1.15 9.971a.48.48 0 0 1 .262-.823L8.868 8.09a.48.48 0 0 0 .36-.257z"
      fill={props.color}
    />
    <Path
      clipRule="evenodd"
      d="M9.228 7.833a.48.48 0 0 1-.36.257L1.412 9.148a.48.48 0 0 0-.262.823l5.376 5.082a.48.48 0 0 1 .143.432l-1.271 7.193a.48.48 0 0 0 .69.51l6.694-3.416a.48.48 0 0 1 .436 0l6.694 3.417a.48.48 0 0 0 .69-.51l-1.271-7.194a.48.48 0 0 1 .143-.432l5.375-5.082a.48.48 0 0 0-.262-.823L17.133 8.09a.48.48 0 0 1-.36-.257l-3.345-6.577a.48.48 0 0 0-.854 0zM13 4.646l-2.063 4.056a2.4 2.4 0 0 1-1.8 1.287l-4.501.638 3.207 3.033c.586.554.854 1.365.714 2.159l-.768 4.349 4.121-2.104a2.4 2.4 0 0 1 2.18 0l4.121 2.104-.768-4.35a2.4 2.4 0 0 1 .713-2.158l3.208-3.033-4.502-.638a2.4 2.4 0 0 1-1.8-1.287z"
      fill={props.color}
      fillRule="evenodd"
    />
  </Svg>
);
const Memo = memo(SvgStar);
export default Memo;
